"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var debounce_1 = require("debounce");
var idAffaireCurrent = null;
$.fn.initPointArret = function () {
    var _this = this;
    var $container = $(this);
    var showHidePa = function showHidePa($el) {
        var onlyOpen = $("#onlyOpen").is(":checked");
        var onlyUserIsReceiver = $("#onlyUserIsReceiver").is(":checked");
        var elAff = $el.data("aff-id");
        if (elAff) {
            if (elAff === idAffaireCurrent) {
                idAffaireCurrent = null;
                $el.removeClass("active show");
            } else {
                idAffaireCurrent = elAff;
            }
        }
        var url = $("input#url-pa").val();
        $.ajax({
            url: url,
            type: "get",
            data: {
                onlyOpen: onlyOpen,
                onlyUserIsReceiver: onlyUserIsReceiver,
                idAffaire: idAffaireCurrent || ($("input#id-affaire").length > 0 ? $("input#id-affaire").val() : null)
            }
        }).done(function (data) {
            $("div.points-arret").html(data);
        });
    },
        goToLastMessage = function goToLastMessage($thread) {
        var $messages = $thread.find("#messages-area"),
            $message = $messages.find("> .row:last");
        if ($message.length > 0) {
            $messages.animate({
                scrollTop: $message.offset().top - $messages.offset().top + $messages.scrollTop()
            }, 0);
        }
    },
        postActionThread = function postActionThread(data) {
        var $thread = $("#message-threads");
        if (data) {
            $thread.html(data);
        }
        //On init les controls
        $thread.find(".select2").select2();
        //On descend le thread au dernier message
        goToLastMessage($thread);
    };
    $("body").on("pa-submitted", function (e, data) {
        $("#message-threads").html(data);
        $("#modal").modal("hide");
        return $(_this);
    })
    //Changement d'affaire
    .on("click", "a[data-aff-id]", function () {
        showHidePa($(this));
    }).on("click", ".pa-filtre", function (e) {
        showHidePa($(this));
    }).on("select2:select", ".new-destinataire", function () {
        var $select = $(this);
        $.post({
            url: "/Affaires/AddDestinataire",
            method: "post",
            data: {
                idPa: $select.data("paId"),
                destinataireId: $select.val()
            }
        }).done(function (data) {
            //On finit l'action
            postActionThread(data);
        });
    }).on("keyup", "input.aff-search", function (e) {
        var $this = $(this);
        var $divAff = $this.parent().next();
        var $items = $divAff.find("a.pa-title");
        $items.show();
        if ($this.val()) {
            $.ajax({
                url: $this.data("url"),
                type: "get",
                data: {
                    term: $this.val()
                }
            }).done(function (data) {
                var ids = $.map(data.results, function (d) {
                    return d.id;
                });
                $items.filter(function (i, el) {
                    return ids.indexOf($(el).data("aff-id")) === -1;
                }).hide();
            });
            //$items.filter((i, el) => { return $(el).data("aff-code").replace(/\./g, "").toUpperCase().indexOf($this.val().toUpperCase()) === -1 }).hide();
        }
    }).on("click", "button.btn-pa-reponse", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $form = $(this).parents(".new-message-form").find("form"),
            idPa = $form.data("id-pa");
        var reponse = $form.find("textarea[name=reponse]").val();
        if (!reponse || reponse === " ") {
            return false;
        }
        // Barre de progression
        var $progress = $form.find(".progress").removeClass("d-none");
        var $progressBar = $progress.find(".progress-bar");
        $progressBar.attr("aria-valuenow", 0);
        $progressBar.width(0);
        var fd = new FormData($form.get(0));
        fd.append("idPa", idPa);
        fd.append("idAff", $form.data("id-aff"));
        $.ajax({
            url: $form.attr("action"),
            type: "post",
            processData: false,
            contentType: false,
            data: fd,
            xhr: function xhr() {
                var xhr = $.ajaxSettings.xhr();
                // Mise à jour de la barre de progression
                if (xhr.upload) {
                    xhr.upload.addEventListener("progress", function (e) {
                        if (!e.lengthComputable) {
                            return;
                        }
                        var pct = e.loaded * 100 / e.total;
                        $progressBar.width(pct + "%");
                    }, false);
                }
                return xhr;
            }
        }).done(function (data) {
            //On finit l'action
            postActionThread(data);
            //On met à jour l'indicateur
            var indicator = $("div.headerAffaire > div.indicateur-point-arret > div.big-indicator > a#paLink");
            indicator.val(parseInt(indicator.val()) + 1);
            //Indicateur de la liste des messages
            indicator = $("a.nav-link[data-id=" + idPa + "] i.fa-comment-o").next();
            indicator.text(parseInt(indicator.text()) + 1);
        });
    }).on("click", "div.pa-container a.page-link", function (e) {
        e.preventDefault();
        $.ajax({
            url: $(this).attr("href"),
            type: "get",
            data: {
                justWithoutAnswer: $("#onlyUnanswered").is(":checked"),
                onlyUserIsReceiver: $("#onlyUserIsReceiver").is(":checked"),
                idAffaire: idAffaireCurrent || ($("input#id-affaire").length > 0 ? $("input#id-affaire").val() : null)
            }
        }).done(function (data) {
            $("div.pa-container").html(data);
        });
    }).on("keyup", ".affaire-search", debounce_1.debounce(function () {
        var $search = $(this),
            val = $search.val(),
            currentValSearch = $search.data("currentSearch");
        val = val && val === 0 ? null : val.toUpperCase();
        if (val && val.length < 2 && val.length > currentValSearch) {
            return;
        }
        $search.data("currentSearch", val);
        $("#pa-titles > a").each(function () {
            var $el = $(this),
                code = $el.data("affaireCode").toUpperCase(),
                libelle = $el.data("affaireLibelle");
            $el.toggle(!val || code.indexOf(val) !== -1 || code.replace(/(-|\.|_)/g, '').indexOf(val) !== -1 || libelle.toUpperCase().indexOf(val) !== -1);
        });
    }))
    // Changement de volet
    .on("shown.bs.tab", "a.nav-item", function (e) {
        var $tab = $(this);
        var tabId = $tab.attr("href");
        $("div.threads-list > div.tab-content > div" + tabId).find("a.nav-link.active").trigger("shown.bs.tab");
    }).on("shown.bs.tab", "[data-id]", function (e) {
        var $tab = $(this);
        var id = $tab.data("id");
        var $thread = $("#message-threads");
        // Charge le thread
        $thread.load("/Affaires/GetPointArret/" + id, function () {
            // On remonte le tab en visu au chargement de la page
            var $parent = $tab.parents(".tab-pane");
            $parent.animate({
                scrollTop: $tab.offset().top - $parent.offset().top + $parent.scrollTop()
            }, 100);
            //On finit l'action
            postActionThread();
            //On affiche l'onglet le cas échéant (surtout valable au chargement de page)
            if (!$parent.hasClass(".active")) {
                $(".threads-tabs").find("a[aria-controls=" + $parent.attr("id") + "]").trigger("click");
            }
        });
    });
    return $container;
};
$.fn.initPointArretModal = function () {
    var $target = $(this);
    if ($("select[data-bc-for-affaire]").length > 0) {
        $.each($("select[data-bc-for-affaire]"), function (i, el) {
            var $el = $(el),
                $source = $($el.data("bc-for-affaire"));
            if ($source.is("select")) {
                $source.select2({
                    placeholder: "Veuillez choisir une affaire",
                    width: "100%",
                    templateResult: function templateResult(selected) {
                        var affaire = selected;
                        if (!affaire.id) {
                            return "";
                        }
                        return $("<span><strong>" + affaire.codeAffaire + "</strong>  " + affaire.libelle + "\n                                    <br />" + affaire.codeInsee + " " + affaire.communeTravaux + "</span>");
                    },
                    ajax: {
                        url: $source.data("url"),
                        dataType: "json",
                        processResults: function processResults(data) {
                            return {
                                results: $.map(data.results, function (d) {
                                    d.text = d.codeAffaire;
                                    return d;
                                })
                            };
                        }
                    }
                });
                $source.on("select2:select", function () {
                    var $this = $(this);
                    $.getJSON($el.data("url") + ("/" + $this.val() + "?typeBc=1"), function (data) {
                        $el.html("");
                        $el.html("<option value=''> &ndash; </option>");
                        $.each(data, function (i, d) {
                            $el.append($("<option>", {
                                value: d.value,
                                text: d.text
                            }));
                        });
                    });
                });
            } else {
                $.getJSON($el.data("url") + ("/" + $source.val() + "?typeBc=1"), function (data) {
                    $el.html("");
                    $el.html("<option value=''> &ndash; </option>");
                    $.each(data, function (i, d) {
                        $el.append($("<option>", {
                            value: d.value,
                            text: d.text
                        }));
                    });
                });
            }
        });
    }
    if ($("select[data-inter-for-affaire]").length > 0) {
        $.each($("select[data-inter-for-affaire]"), function (i, el) {
            var $el = $(el),
                $source = $($el.data("inter-for-affaire"));
            if ($source.is("select")) {
                $source.on("select2:select", function () {
                    var $this = $(this);
                    $.getJSON($el.data("url") + ("/" + $this.val()), function (data) {
                        $el.html("");
                        $el.html("<option value=''> &ndash; </option>");
                        $.each(data, function (i, d) {
                            $el.append($("<option>", {
                                value: d.value,
                                text: d.text
                            }));
                        });
                    });
                });
            } else {
                $.getJSON($el.data("url") + ("/" + $source.val()), function (data) {
                    $el.html("");
                    $el.html("<option value=''> &ndash; </option>");
                    $.each(data, function (i, d) {
                        $el.append($("<option>", {
                            value: d.value,
                            text: d.text
                        }));
                    });
                });
            }
        });
    }
    return $target;
};
$(".points-arret").initPointArret();


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/PointArrets/index.ts
// module id = 516
// module chunks = 0